import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '@/lib/api';
import { useAuth } from '@/context/AuthContext';

const ClientContext = createContext(null);

export function ClientProvider({ children }) {
  const { user } = useAuth();
  const [clients, setClients] = useState([]);
  const [activeId, setActiveId] = useState(() => localStorage.getItem('aos-active-client') || null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await api.get('/clients');
      setClients(data || []);
      if (!activeId && data && data.length > 0) {
        setActiveId(data[0].client_id);
        localStorage.setItem('aos-active-client', data[0].client_id);
      } else if (activeId && data && !data.find(c => c.client_id === activeId) && data.length > 0) {
        setActiveId(data[0].client_id);
        localStorage.setItem('aos-active-client', data[0].client_id);
      }
    } finally {
      setLoading(false);
    }
  }, [user, activeId]);

  useEffect(() => { load(); }, [user, load]);

  const selectClient = (id) => {
    setActiveId(id);
    localStorage.setItem('aos-active-client', id);
  };

  const activeClient = clients.find(c => c.client_id === activeId) || null;

  return (
    <ClientContext.Provider value={{ clients, activeClient, activeId, selectClient, refresh: load, loading }}>
      {children}
    </ClientContext.Provider>
  );
}

export const useClient = () => useContext(ClientContext);
